import React from 'react';
import { IonIcon, IonButton, IonAlert } from '@ionic/react';
import moment from 'moment';
import Modal from '../../components/modal';
import { Title, StrongText, SmallText, NormalText, Subtitle, Spacer } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { informationCircleOutline, checkmarkCircle, checkmark, checkmarkOutline, chevronForward, lockClosed, gift } from 'ionicons/icons';
import { getConfig } from '../../appConfig';
import { forwardTo } from '../../lib/utils';
import { getMilestoneRewardsInfo, getUnlockRewardsInfo, buyReward } from '../../store/actions';
import { connect } from 'react-redux';
import Slider, { Slide } from '../../components/slider';
import { VoucherModal } from '../../screens/voucher';

class Rewards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalData: null,
            buyRewardModalOpen: false,
            selectedReward: null,
            selectedVoucher: null
        };
    }
    componentDidMount() {
        if (this.props.unlockRewards) {
            this.props.dispatch(getUnlockRewardsInfo());

        }
        if (this.props.milestoneRewards) {
            this.props.dispatch(getMilestoneRewardsInfo());

        }

    }

    redeemReward = (reward) => {
        this.props.dispatch(buyReward({ atreemo: reward.source == 'atreemo', rewardId: reward.id }));
    };

    // Given all vouchers that belong to a reward, return the one whose
    // expiry_date is closest to today (null when there are none).
    getClosestVoucher = (rewardVouchers) => {
        if (!rewardVouchers || rewardVouchers.length === 0) {
            return null;
        }
        const today = moment();
        return [...rewardVouchers].sort(
            (a, b) =>
                Math.abs(moment(a.expiry_date, 'YYYY/MM/DD').diff(today)) -
                Math.abs(moment(b.expiry_date, 'YYYY/MM/DD').diff(today)),
        )[0];
    };

    getMilestoneRewardsData = (rewards, balance) => {
        if (!Array.isArray(rewards) || rewards.length === 0) {
            return { rewards: [], nextRewardPoints: 0 };
        }

        const sorted = [...rewards].sort((a, b) => a.stamps_required - b.stamps_required);
        const lastThreshold = sorted[sorted.length - 1].stamps_required;

        if (balance >= lastThreshold) {
            const finalList = sorted.map((item, index) => {
                const prev = index === 0 ? 0 : sorted[index - 1].stamps_required;
                const segmentSize = item.stamps_required - prev;

                return {
                    ...item,
                    percentageFilled: '100%',
                    percentage: `${((segmentSize / lastThreshold) * 100).toFixed(2)}%`,
                    earned: true,
                };
            });

            return { rewards: finalList, nextRewardPoints: 0 };
        }

        let prevThreshold = 0;
        let foundNext = false;
        let nextRewardPoints = 0;

        const processed = sorted.map((item) => {
            const currentThreshold = item.stamps_required;
            const segmentSize = currentThreshold - prevThreshold;

            let filledPercent;
            if (balance >= currentThreshold) {
                filledPercent = 100;
            } else if (balance <= prevThreshold) {
                filledPercent = 0;
            } else {
                const inside = balance - prevThreshold;
                filledPercent = +(inside / segmentSize * 100).toFixed(2);
            }

            if (!foundNext && balance < currentThreshold) {
                nextRewardPoints = currentThreshold - balance;
                foundNext = true;
            }

            const percentageOfTotal = +((segmentSize / lastThreshold) * 100).toFixed(2);
            const earned = balance >= currentThreshold;

            prevThreshold = currentThreshold;

            return {
                ...item,
                percentageFilled: `${Math.floor(filledPercent)}%`,
                percentage: `${percentageOfTotal}%`,
                earned,
            };
        });

        return { rewards: processed, nextRewardPoints };
    };

    render() {
        const { __, milestoneInfo, available_points, unlockRewardsInfo, unlockRewards, milestoneRewards, qr_code, vouchers } = this.props;
        const { modalData, buyRewardModalOpen, selectedReward, selectedVoucher } = this.state
        const { rewards, nextRewardPoints } = this.getMilestoneRewardsData(this.props.rewards, available_points);
        const earnedRewards = rewards.filter(r => r.earned);
        const nextReward = rewards.find(r => !r.earned);
        const nextUpIndex = rewards.findIndex(r => !r.earned);
        const nextRewardName = nextReward?.name || null;
        const maxProgressBarLength = parseInt(getConfig().general?.rewardsProgressBarMaximumLength, 10) || 0;
        const allDisplayRewards = nextReward ? [...earnedRewards, nextReward] : earnedRewards;
        const displayRewards = maxProgressBarLength ? allDisplayRewards.slice(-maxProgressBarLength) : allDisplayRewards;
        const totalPct = displayRewards.reduce((sum, r) => sum + parseFloat(r.percentage), 0);
        const scaledRewards = displayRewards.map(r => ({
            ...r,
            percentage: totalPct > 0 ? `${(parseFloat(r.percentage) / totalPct * 100).toFixed(2)}%` : r.percentage,
        }));
        let availableUnlockVouchers = []
        let redeemedUnlockVouchers = []
        if (unlockRewards) {
            availableUnlockVouchers = Object.values(
                (vouchers || [])
                    .filter((voucher) => !voucher.is_redeemed)
                    .reduce((acc, voucher) => {
                        const key = voucher.reward?.id;
                        if (!acc[key]) acc[key] = [];
                        acc[key].push(voucher);
                        return acc;
                    }, {}),
            ).map((group) =>
                [...group].sort(
                    (a, b) =>
                        moment(a.expiry_date, 'YYYY/MM/DD') - moment(b.expiry_date, 'YYYY/MM/DD'),
                )[0],
            );
            redeemedUnlockVouchers = Object.values(
                (vouchers || [])
                    .filter((voucher) => voucher.is_redeemed)
                    .reduce((acc, voucher) => {
                        const key = voucher.reward?.id;
                        if (!acc[key]) acc[key] = [];
                        acc[key].push(voucher);
                        return acc;
                    }, {}),
            ).map((group) =>
                [...group].sort(
                    (a, b) =>
                        moment(a.expiry_date, 'YYYY/MM/DD') - moment(b.expiry_date, 'YYYY/MM/DD'),
                )[0],
            );
        }
        return (
            <>

                <div className='reward-wrapper box-wrapper'>
                    <div className='reward-header reward-header-loyalty'>
                        <Title >{__('Your rewards')}</Title>
                        <IonIcon onClick={() => this.setState({ modalData: milestoneRewards ? milestoneInfo : unlockRewardsInfo })} icon={informationCircleOutline} />
                    </div>
                    <div className='reward-header' style={{ alignItems: 'center', border: 'none', paddingBottom: '0' }}>
                        <div>
                            <SmallText className='reward-color-text is-uppercase'>{__('Your balance')}</SmallText>
                            <Spacer size={0} />
                            <div style={{ display: 'flex', gap: '5px', alignItems: 'baseline' }}>
                                <Title style={{ lineHeight: '1' }} className={'reward-color-text-dark reward-header-title no-decorator'}>{available_points}</Title>
                                <StrongText className='reward-color-text bold' style={{ lineHeight: '1' }}>{available_points == 1 ? __('pt') : __('pts')}</StrongText>
                            </div>
                        </div>
                        {nextRewardPoints > 0 ?
                            <div style={{ display: 'grid', justifyItems: 'flex-end' }}>
                                <StrongText >{__(nextRewardPoints == 1 ? '{points} pt to' : '{points} pts to', { points: nextRewardPoints })}</StrongText>
                                <StrongText className='reward-color-text-dark'>{nextRewardName}</StrongText>
                            </div>
                            :
                            <div className='rewards-unlocked'>
                                <SmallText className='bold reward-color-text-dark bold'>{__('MAX · all unlocked')}</SmallText>
                            </div>
                        }
                    </div>
                    <div className='reward-progress-wrapper'>
                        <div className='reward-progress-bar'>
                            {scaledRewards.map((el, rewardIndex) => (
                                <div key={`reward_${rewardIndex}`} style={{ flex: 1 }}>
                                    <div style={{ display: 'grid', gridAutoFlow: 'column', alignItems: 'center', justifyContent: 'flex-end', gap: '5px' }}>

                                        <SmallText className={`bold reward-bar-label ${el.earned ? 'reward-color-text-dark' : ''}`}>{el.stamps_required}</SmallText>
                                        <div className={`reward-bar-icon ${!el.earned ? 'reward-bar-icon-locked' : ''}`}
                                        >
                                            <IonIcon
                                                icon={el.earned ? checkmarkOutline : lockClosed}
                                            />
                                        </div>
                                    </div>
                                    <div className='reward-bar-track' data-percentagefilled={el.percentageFilled}>
                                        <span style={{ width: el.percentageFilled }}></span>
                                    </div>

                                    <SmallText className='reward-bar-label-small reward-bar-label reward-color-text'>{el.name}</SmallText>
                                </div>
                            ))}
                        </div>


                    </div>
                    {unlockRewards &&
                        <>
                            <div className='unlock-rewards-slider'>
                                <SmallText style={{ paddingLeft: 'var(--ion-padding)' }} className='reward-color-text'>{__('REDEEM YOUR POINTS')}</SmallText>
                                <Spacer size={1} />
                                <Slider
                                    key={`unlock-slider-${nextUpIndex}-${rewards.length}`}
                                    settings={{
                                        slidesPerView: 2.2,
                                        spaceBetween: 12,
                                        slidesOffsetBefore: 0,
                                        centeredSlides: false,
                                        loop: false,
                                        initialSlide: Math.max(0, nextUpIndex - 1),
                                        pagination: {
                                            el: '.swiper-pagination',
                                            clickable: true,
                                        },
                                    }}
                                >
                                    {rewards.map((reward, index) => {
                                        const locked = available_points < reward.stamps_required;
                                        const isNextUp = index === nextUpIndex;
                                        return (
                                            <Slide key={'unlock-rw-' + index}>
                                                <div className={`unlock-reward-item`}>
                                                    <img src={reward.reward?.image} alt={reward.name} />
                                                    <div className='unlock-reward-content'>

                                                        <StrongText className='block unlock-reward-title'>{reward.name}</StrongText>
                                                        <StrongText className='reward-color-text-dark' style={{ alignItems: 'center', display: 'flex', gap: '3px' }}>
                                                            {reward.stamps_required}
                                                            <SmallText className='reward-smaller-text reward-color-text bold'>{__(reward.stamps_required == 1 ? 'pt' : 'pts')}</SmallText>

                                                        </StrongText>
                                                        {locked ? (
                                                            <SmallText style={{ display: "flex", alignItems: 'center', gap: '3px' }} className='bold reward-color-text reward-points-to-go'>
                                                                <IonIcon style={{ height: '10px', width: '10px' }} icon={lockClosed} />
                                                                {__('{points} to go', { points: reward.stamps_required - available_points })}
                                                            </SmallText>
                                                        ) : (
                                                            <div className='unlock-reward-redeem dark-reward-btn' onClick={() => this.setState({ selectedReward: reward, buyRewardModalOpen: true })}>
                                                                <SmallText>{__('Redeem')}</SmallText>
                                                            </div>

                                                        )}
                                                    </div>

                                                    {isNextUp && (
                                                        <div className='reward-next-up dark-reward-btn'>
                                                            <SmallText className='reward-smaller-text'>{__('NEXT UP')}</SmallText>
                                                        </div>
                                                    )}
                                                </div>
                                            </Slide>
                                        );
                                    })}
                                    <div className="swiper-pagination"></div>
                                </Slider>

                            </div>
                            {(availableUnlockVouchers.length > 0 || redeemedUnlockVouchers.length > 0) &&
                                <div className='unlock-rewards-list-wrapper'>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <SmallText className='reward-color-text is-uppercase'>{__('Your vouchers')}</SmallText>
                                        <div className='unlock-rewards-list-btn'>
                                            <SmallText className='bold dark-reward-btn'>{__(`{number} ready to use`, { number: availableUnlockVouchers.length })}</SmallText>
                                        </div>
                                    </div>
                                    {availableUnlockVouchers.length > 0 &&
                                        <>
                                            <Spacer size={2} />
                                            <SmallText style={{ fontSize: 'calc(var(--okx-small-text-font-size) - 1.5px)' }} className='reward-color-text is-uppercase'>{__('To redeem')}</SmallText>

                                            <div className='unlock-rewards-list'>

                                                {availableUnlockVouchers.map((voucher, index) => (
                                                    <div
                                                        key={'unlock-voucher-' + index}
                                                        className='unlock-rewards-list-item pointer'
                                                        onClick={() => this.setState({ selectedVoucher: voucher })}
                                                    >
                                                        <img className='unlock-rewards-list-item-image' src={voucher.reward?.image} alt={voucher.reward?.name} />
                                                        <div className='unlock-rewards-list-item-content'>
                                                            <StrongText className='block'>{voucher.reward?.name}</StrongText>
                                                            <SmallText className='reward-color-text'>{`${__('Expires')} ${moment(voucher.expiry_date, 'YYYY/MM/DD').format('DD MMM YYYY')}`}</SmallText>
                                                        </div>
                                                        <div className='unlock-rewards-list-item-btn dark-reward-btn bold'>
                                                            <SmallText>{__('Use now')}</SmallText>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>

                                    }
                                    {redeemedUnlockVouchers.length > 0 &&
                                        <>
                                            <Spacer size={2} />

                                            <SmallText style={{ fontSize: 'calc(var(--okx-small-text-font-size) - 1.5px)' }} className='reward-color-text is-uppercase'>{__('REDEEMED')}</SmallText>

                                            <div className='unlock-rewards-list'>
                                                {redeemedUnlockVouchers.map((voucher, index) => (
                                                    <div
                                                        key={'unlock-voucher-' + index}
                                                        className='unlock-rewards-list-item unlock-rewards-list-item-redeemed'
                                                    >
                                                        <img className='unlock-rewards-list-item-image' src={voucher.reward?.image} alt={voucher.reward?.name} />
                                                        <div className='unlock-rewards-list-item-content'>
                                                            <StrongText className='block'>{voucher.reward?.name}</StrongText>
                                                            {voucher.date_redeemed &&
                                                                <SmallText className='reward-color-text'>{`${__('Redeemed')} ${moment(voucher.date_redeemed, 'YYYY/MM/DD').format('DD MMM YYYY')}`}</SmallText>

                                                            }
                                                        </div>
                                                        <div className='unlock-rewards-list-item-btn unlock-rewards-list-item-btn-redeemed'>
                                                            <IonIcon icon={checkmark} />
                                                            <SmallText>{__('Used')}</SmallText>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                            <IonAlert
                                isOpen={buyRewardModalOpen}
                                onDidDismiss={() => this.setState({ buyRewardModalOpen: false })}
                                header={__('Are you sure?')}
                                message={__(selectedReward?.stamps_required == 1 ? 'Are you sure you wish to redeem {count} point in exchange for the following voucher: {name}' : 'Are you sure you wish to redeem {count} points in exchange for the following voucher: {name}', { count: selectedReward?.stamps_required, name: selectedReward?.name })}
                                buttons={[
                                    {
                                        text: __('Redeem'),
                                        cssClass: 'primary',
                                        handler: () => this.redeemReward(selectedReward),
                                    },
                                    {
                                        text: __('Cancel'),
                                        role: 'cancel',
                                        cssClass: 'secondary link',
                                    },
                                ]}
                            />
                        </>
                    }

                    {milestoneRewards &&
                        <div className='milestone-rewards-wrapper'>
                            {nextReward &&
                                <div className='milestone-next-reward'>
                                    <div className='reward-next-up dark-reward-btn'>
                                        <SmallText className='reward-smaller-text '>{__('NEXT REWARD')}</SmallText>
                                    </div>
                                    <img className='milestone-next-reward-image' src={nextReward.reward?.image} alt={nextReward.name} />
                                    <div className='milestone-next-reward-content'>
                                        <Title className='block milestone-next-reward-title'>{nextReward.name}</Title>
                                        <Spacer size={1} />

                                        <div className='reward-bar-track' data-percentagefilled={nextReward.percentageFilled}>
                                            <span style={{ width: nextReward.percentageFilled }}></span>
                                        </div>
                                        <Spacer size={1} />
                                        <div style={{ display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                                            <NormalText className='reward-color-text'>{__('{points} to go', { points: nextRewardPoints })}</NormalText>
                                            <StrongText style={{ display: 'flex', alignItems: 'center', gap: '3px' }} className='reward-color-text-dark'>{`${nextReward.stamps_required}`} <SmallText className='reward-color-text bold'>{__(nextReward.stamps_required == 1 ? 'pt' : 'pts')}</SmallText></StrongText>
                                        </div>
                                    </div>
                                </div>
                            }


                            <div className='milestone-rewards-list-wrapper'>
                                <SmallText className='reward-color-text'>{__('ALL REWARDS')}</SmallText>
                                <div className='milestone-rewards-list'>
                                    {rewards.map((reward, index) => {
                                        const isNextReward = index === nextUpIndex;
                                        const enoughPoints = reward.earned;
                                        const pointsToGo = reward.stamps_required - available_points;
                                        // A reward is matched to its vouchers via reward.id.
                                        const rewardVouchers = (vouchers || []).filter(
                                            (voucher) => voucher.reward?.id === reward.reward.id,
                                        );
                                        // A non-redeemed voucher makes the reward redeemable and
                                        // takes precedence over the points requirement.
                                        const closestVoucher = this.getClosestVoucher(
                                            rewardVouchers.filter((voucher) => !voucher.is_redeemed),
                                        );
                                        const canRedeem = !!closestVoucher;
                                        // Enough points but every voucher redeemed (or none left) => already redeemed.
                                        const isRedeemed = !canRedeem && enoughPoints;
                                        const unlocked = canRedeem || enoughPoints;
                                        return (
                                            <div onClick={() => canRedeem && this.setState({ selectedVoucher: closestVoucher })} className={`${canRedeem ? 'pointer' : ''} milestone-rewards-list-item ${isNextReward ? 'milestone-rewards-list-item-next' : ''}`} key={'milestone-rw-' + index}>
                                                <div className={`reward-bar-icon ${!unlocked ? 'reward-bar-icon-locked' : ''}`}>
                                                    <IonIcon icon={unlocked ? checkmarkOutline : lockClosed} />
                                                </div>
                                                <div className='milestone-rewards-list-item-content'>
                                                    <StrongText className='block'>{reward.name}</StrongText>
                                                    {canRedeem ? (
                                                        <SmallText className='reward-color-text-dark bold' >
                                                            {__('Ready to redeem')}
                                                        </SmallText>
                                                    ) : isRedeemed ? null : isNextReward ? (
                                                        <SmallText className='bold' style={{ display: 'flex', alignItems: 'center', gap: '3px' }} >
                                                            {__(pointsToGo == 1 ? '{points} pt to go' : '{points} pts to go', { points: pointsToGo })}
                                                        </SmallText>
                                                    ) : (
                                                        <SmallText className='reward-locked' style={{ display: 'flex', alignItems: 'center', gap: '3px' }} >
                                                            {__('Locked')}
                                                        </SmallText>
                                                    )}
                                                </div>
                                                <StrongText style={{ display: 'flex', alignItems: 'center', gap: '3px' }} className='reward-color-text-dark'>
                                                    {canRedeem ? (
                                                        <div className='milestone-item-redeem-btn'>
                                                            <SmallText className='pointer reward-color-dark bold'>{__('Redeem')}</SmallText>

                                                        </div>
                                                    ) : isRedeemed ? (
                                                        <SmallText className='reward-color-text bold'>{__('Redeemed')}</SmallText>
                                                    ) : (
                                                        <>
                                                            {reward.stamps_required}
                                                            <SmallText className='reward-color-text bold'>{__(reward.stamps_required == 1 ? 'pt' : 'pts')}</SmallText>
                                                        </>
                                                    )}
                                                </StrongText>
                                            </div>
                                        );
                                    })}
                                </div>

                            </div>
                        </div>
                    }
                </div>
                <Modal
                    className="loyalty-faq-modal"
                    isOpen={!!modalData}
                    onDidDismiss={() => this.setState({ modalData: null })}
                >
                    <div className="lefted">
                        <Title className='modal-title'>{__('Rewards')}</Title>
                        <div dangerouslySetInnerHTML={{ __html: modalData }}></div>
                    </div>
                </Modal>

                <VoucherModal
                    voucher={selectedVoucher}
                    onDismiss={() => this.setState({ selectedVoucher: null })}
                />

            </>
        );
    }
}



const stateToProps = (state) => ({
    milestoneInfo: state.common.milestoneInfo,
    unlockRewardsInfo: state.common.unlockRewardsInfo,

});

export default connect(stateToProps)(withTranslation(Rewards));
